module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('header', {
    staticClass: "live-run-inner"
  }, [(_vm.racesInProgress.length !== 0) ? _c('race-list', {
    attrs: {
      "subtitle": "in progress",
      "races": _vm.racesInProgress
    }
  }) : _vm._e(), _vm._v(" "), _c('race-list', {
    attrs: {
      "subtitle": "to start",
      "races": _vm.racesToStart,
      "message-empty-list": "You don't have upcoming races."
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b41d8f16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/LiveRun.vue
// module id = 1712
// module chunks = 1